import { render, staticRenderFns } from "./ClassTrialBehaviorTable.vue?vue&type=template&id=0d797255"
import script from "./ClassTrialBehaviorTable.vue?vue&type=script&lang=js"
export * from "./ClassTrialBehaviorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports